<template>
  <b-modal
    @hide="onHandleCloseModal('otpModal')"
    :visible="getModals.otpModal"
    :id="getModals.otpId"
    :ref="getModals.otpId"
    title="OTP Verification"
    class="imp-popup"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <div>
      <div class="p-3">
        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
          <div class="row">
            <div class="col-12 text-center">
              Almost there! Please enter the 4 digit verification
              <br />code you might have just received on whatsApp.
            </div>
            <div class="col-12 text-center my-5">
              <OtpInput
                @focus="resetVerifyUserErrors"
                @on-change="
                  value =>
                    onOTPValue({
                      event: null,
                      name: 'userOTP',
                      value: value
                    })
                "
                ref="otpInput"
                :is-input-num="true"
                :num-inputs="4"
                :should-auto-focus="true"
              />
              <!-- OTP valid time -->

              <countdown
                :time="3 * 60 * 1000"
                :disabled="getOtpCounting"
                tag="div"
                @end="onOtpCountingEnd"
              >
                <template slot-scope="props">
                  <!-- <div class="mt-2 text-rose-gold font-weight-bold">02:57s left</div> -->
                  <div class="mt-2 text-rose-gold font-weight-bold">
                    Your current OTP will expire in {{ props.minutes }}:{{
                      props.seconds
                    }}m
                  </div>
                </template>
              </countdown>
            </div>
            <div class="col-12 mb-4">
              <button class="btn btn-primary w-100" @click="onSubmitOTP">
                Verify
              </button>
            </div>
            <div
              :class="[
                'col-12 text-center mb-3',
                getOtpTimerExpired ? null : 'd-none'
              ]"
            >
              <span class="text-muted">Didnt receive an OTP?</span>
              <router-link @click.native="onResendOTP" to class
                >Resend</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import OtpInput from "@/plugins/OTP/OtpInput.vue";

export default {
  components: {
    OtpInput
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      // Modal
      "getModals",
      // ERROR
      // OTP
      "getOtpCounting",
      "getOtpTimerExpired"
    ])
  },
  methods: {
    ...mapActions([
      "onHandleCloseModal",
      "onOTPValue",
      "onSubmitOTP",
      "onOtpCountingEnd",
      "onResendOTP"
    ]),
    resetVerifyUserErrors(event) {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modals/otp.vue